import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMobileChat = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M29 19H21L17 21V11C17 10.4696 17.2107 9.96086 17.5858 9.58579C17.9609 9.21071 18.4696 9 19 9H29C29.5304 9 30.0391 9.21071 30.4142 9.58579C30.7893 9.96086 31 10.4696 31 11V17C31 17.5304 30.7893 18.0391 30.4142 18.4142C30.0391 18.7893 29.5304 19 29 19Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 11H12C11.4696 11 10.9609 11.2107 10.5858 11.5858C10.2107 11.9609 10 12.4696 10 13V29C10 29.5304 10.2107 30.0391 10.5858 30.4142C10.9609 30.7893 11.4696 31 12 31H23C23.5304 31 24.0391 30.7893 24.4142 30.4142C24.7893 30.0391 25 29.5304 25 29V22",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgMobileChat);
export default ForwardRef;
